// You can customize the template with the help of this file

//Template config options
const themeConfig = {
  app: {
    appName: "WPCloud",
    appLogoImage: require("@src/assets/images/liscr_logo.png"),
    successStatusImage: require("@src/assets/images/success_status.png"),
    errorStatusImage: require("@src/assets/images/error_status.png"),
    ziploader: require("@src/assets/images/loader.gif")
  },
  navicons: {
    home1: require("@src/assets/images/icons/grey/home.png"),
    home2: require("@src/assets/images/icons/white/home.png"),

    corporate1: require("@src/assets/images/icons/grey/corporate.png"),
    corporate2: require("@src/assets/images/icons/white/corporate.png"),

    maritime1: require("@src/assets/images/icons/grey/maritime.png"),
    maritime2: require("@src/assets/images/icons/white/maritime.png"),

    seafarers1: require("@src/assets/images/icons/grey/seafarers.png"),
    seafarers2: require("@src/assets/images/icons/white/seafarers.png"),

    contactManagement1: require("@src/assets/images/icons/grey/contact-management.png"),
    contactManagement2: require("@src/assets/images/icons/white/contact-management.png"),

    // dashboard: require("@src/assets/images/nav_icons/dashboard_icon.png"),
    // dashboard1: require("@src/assets/images/nav_icons/dashboard_icon.png")

    // dlibrary: require("@src/assets/images/nav_icons/folder_black.png"),
    // logout: require("@src/assets/images/navicons/user_profile.png"),
    // notification: require("@src/assets/images/navicons/notification.svg"),
    user: require("@src/assets/images/navicons/user_profile.png")
    // rotate: require("@src/assets/images/nav_icons/rotate-right.png"),
    // more: require("@src/assets/images/nav_icons/more.png"),
    // rotate1: require("@src/assets/images/nav_icons/rotate_right1.png"),
    // more1: require("@src/assets/images/nav_icons/more1.png"),
    // invoice: require("@src/assets/images/invoice.png"),
    // Right_Tick: require("@src/assets/images/nav_icons/Right_Tick.png"),
    // waypoint: require("@src/assets/images/nav_icons/waypoint.png"),
    // peopleOutline: require("@src/assets/images/nav_icons/people-outline.png"),
    // cloudOutline: require("@src/assets/images/nav_icons/cloud-outline.png"),
    // billing: require("@src/assets/images/nav_icons/billing.png")
  },
  layout: {
    isRTL: false,
    skin: "light", // light, dark, bordered, semi-dark
    type: "vertical", // vertical, horizontal
    contentWidth: "boxed", // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: true
      //isCollopsed we have kept instead iscollapsed :false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "sticky", // static , sticky , floating, hidden
      backgroundColor: "white" // BS color options [primary, success, etc]
    },
    footer: {
      type: "static" // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true, // Enable scroll to top button
    toastPosition: "top-right" // top-left, top-center, top-right, bottom-left, bottom-center, bottom-right
  }
}

export default themeConfig
